<div class="db-ecommerce-enable">
    <div class="db-ecommerce-enable__title"><span [innerHTML]="'text_ecommerce.enableTitle' | dbText"></span></div>
    <div class="db-ecommerce-enable__desc"><span [innerHTML]="'text_ecommerce.enableDesc' | dbText"></span></div>

    <ds-tabs (onActiveTabChange)="setActiveTab($event.tabId)" [activeTabId]="activeTab"
             class="db-ecommerce-enable__tabs">
        <ds-tab-head *ngFor="let tab of tabs" [activeTabId]="activeTab" [tabId]="tab?.id">
            <span [innerHTML]="tab?.label | dbText" class="db-ecommerce-enable__tabs-title"></span>
        </ds-tab-head>
        <ds-tab-content [activeTabId]="activeTab" [tabId]="activeTab" class="mt40">
            <ng-container *ngIf="activeTab === 'widgets'" [ngTemplateOutlet]="widgets"></ng-container>
            <ng-container *ngIf="activeTab === 'pages'" [ngTemplateOutlet]="pages"></ng-container>
            <ng-container *ngIf="activeTab === 'dashboard'" [ngTemplateOutlet]="dashboard"></ng-container>
        </ds-tab-content>
    </ds-tabs>
</div>


<ng-template #widgets>
    <div class="db-main-left-side"></div>
    <div class="db-main-right-side">
        <div class="db-tab-header mb12">{{'text_premiumWidgetsTemplates' | dbText}}</div>
        <div [innerHTML]="'text_ecommercePremiumWidgets' | dbText" class="db-tab-content mb10"></div>
        <ul class="db-tab-features mb30">
            <li *ngFor="let feature of features" class="mb10">
                <img alt="" src="assets/images/icons/checkmark-white-blue.svg"/>
                <p>{{ feature | dbText }}</p>
            </li>
        </ul>
        <button (click)="onEnable.emit()" [ngClass]="{'ds-btn-disabled': false}" class="ds-btn-black ds-btn-l">
            <span *ngIf="!loading">{{'text_enableEcommerceFeatures' | dbText}}</span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </button>
    </div>
</ng-template>

<ng-template #pages>
    <div class="db-main-left-side"></div>
    <div class="db-main-right-side">
        <div class="db-tab-header mb12">{{'text_createProductPagesAI' | dbText}}</div>
        <div [innerHTML]="'text_ecommerceProductPages' | dbText" class="db-tab-content mb10"></div>
        <ul class="db-tab-features mb30">
            <li *ngFor="let feature of features" class="mb10">
                <img alt="" src="assets/images/icons/checkmark-white-blue.svg"/>
                <p>{{ feature | dbText }}</p>
            </li>
        </ul>
        <button (click)="onEnable.emit()" [ngClass]="{'ds-btn-disabled': false}" class="ds-btn-black ds-btn-l">
            <span *ngIf="!loading">{{'text_enableEcommerceFeatures' | dbText}}</span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </button>
    </div>
</ng-template>

<ng-template #dashboard>
    <div class="db-main-left-side"></div>
    <div class="db-main-right-side">
        <div class="db-tab-header mb12">{{'text_allInOneEcommerceDashboard' | dbText}}</div>
        <div [innerHTML]="'text_ecommerceDashboard' | dbText" class="db-tab-content mb10"></div>
        <ul class="db-tab-features mb30">
            <li *ngFor="let feature of features" class="mb10">
                <img alt="" src="assets/images/icons/checkmark-white-blue.svg"/>
                <p>{{ feature | dbText }}</p>
            </li>
        </ul>
        <button (click)="onEnable.emit()" [ngClass]="{'ds-btn-disabled': false}" class="ds-btn-black ds-btn-l">
            <span *ngIf="!loading">{{'text_enableEcommerceFeatures' | dbText}}</span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
        </button>
    </div>
</ng-template>
